<template>
  <div>
  <Card>
      <Row>
        <i-col span="24" :md="18">
          <Form ref="searchForm" inline :model="searchForm" :label-width="100" @submit.native.prevent>
            <FormItem label="申请人/应用名称" prop="name">
              <i-input v-model="searchForm.name" placeholder="请输入申请人/应用名称" style="width: 200px;"></i-input>
            </FormItem>
            <FormItem :label-width="0" class="mob-align-right">
              <Button type="primary" @click="getProjectflowsList()">搜索</Button>
              <Button @click="searchReset" style="margin-left: 10px;">重置</Button>
            </FormItem>
          </Form>
        </i-col>
        <i-col span="24" :md="6">
          <Button style="float: right;" v-show="isProjectflowAdd" @click="addProject" type="primary" :style="{marginBottom: '10px'}" icon="md-add">添加应用</Button>
        </i-col>
       </Row>
      <tables search-place="top" v-model="tableData" :columns="columns" @on-sort-change="changeSort"/>
      <Row style="margin: 10px;">
        <div style="float: right;">
          <page :total="count" :current="page" :page-size="size" @on-change="getProjectflowsList"></page>
        </div>
     </Row>
      <Drawer
        title="添加应用"
        v-model="change"
        width="500"
        :mask-closable="true"
        @on-close="drawerClose"
      >
        <i-form ref="formItem" :model="formItem" :label-width="100" :rules="ruleValidate">
          <form-item label="项目名(中文)" prop="name">
            <i-input v-model="formItem.name" placeholder="输入项目中文名称"></i-input>
          </form-item>
          <form-item label="项目名(英文)" prop="name_en">
            <i-input  v-model="formItem.name_en" placeholder="输入项目英文名称"></i-input>
          </form-item>
          <form-item label="开发语言" prop="language">
             <i-select v-model="formItem.language" @on-change="onSelectLaguageChange">
              <i-option v-for="item in languageList" :value="item.name" :key="item.name" :label="item.name"></i-option>
             </i-select>
          </form-item>
          <form-item label="项目类型" prop="project_type" v-show="project_type_show">
            <i-select v-model="formItem.project_type" >
                  <Option value="WebApplication">WebApplication</Option>
                  <Option value="Website">Website</Option>
             </i-select>
          </form-item>
          <form-item label="代码管理" prop="version_control">
             <i-select v-model="formItem.version_control" @on-change="onSelectGitOrSvn">
                  <!-- <Option value="svn">SVN</Option> -->
                  <Option value="git">Git</Option>
             </i-select>
          </form-item>
          <form-item label="项目所在组" prop="group" v-show="group_visible">
             <i-select v-model="formItem.group">
              <i-option v-for="item in gitlabGroupOptions" :value="item.name" :key="item.name" :label="item.name"></i-option>
             </i-select>
          </form-item>
          <!-- <form-item label="代码服务器" prop="host">
            <i-input  v-model="formItem.host" placeholder="请输入项目所在服务器的IP"></i-input>
          </form-item> -->
          <form-item label="项目经理" prop="masters">
             <i-select v-model="formItem.masters" filterable  multiple>
              <i-option v-for="item in user_all" :value="item.username" :key="item.username" :label="item.username"></i-option>
             </i-select>
          </form-item>
          <form-item label="产品经理" prop="pms">
             <i-select v-model="formItem.pms" filterable  multiple>
              <i-option v-for="item in user_all" :value="item.username" :key="item.username" :label="item.username"></i-option>
             </i-select>
          </form-item>
           <form-item label="开发人员" prop="developers">
             <i-select v-model="formItem.developers" filterable  multiple>
              <i-option v-for="item in user_all" :value="item.username" :key="item.username" :label="item.username"></i-option>
             </i-select>
          </form-item>
           <form-item label="测试人员" prop="tests">
             <i-select v-model="formItem.tests" filterable multiple>
              <i-option v-for="item in user_all" :value="item.username" :key="item.username" :label="item.username"></i-option>
             </i-select>
          </form-item>
          <form-item label="维护人员" prop="maintain">
             <i-select v-model="formItem.maintain" filterable multiple>
              <i-option v-for="item in user_all" :value="item.username" :key="item.username" :label="item.username"></i-option>
             </i-select>
          </form-item>
          <FormItem
                v-for="(item, index) in formItem.steps"
                :key="index"
                :label="item.name"
                :prop="'steps.' + index + '.users_sel'"
                :rules="{required: true, message: '步骤-' + item.id +'不能为空', trigger: 'change', type: 'array'}">
             <i-select v-model="item.users_sel"  multiple>
               <i-option v-for="user in item.users_all" :value="user" :key="user" :label="user"></i-option>
             </i-select>
          </FormItem>
           <form-item label="项目描述" prop="description" >
            <i-input  v-model="formItem.description" placeholder="请输入项目描述信息" type="textarea"></i-input>
          </form-item>
          <form-item>
           <i-button type="primary" @click="handleSubmit('formItem')">提交</i-button>
           <i-button style="margin-left: 8px" @click="change=false">取消</i-button>
          </form-item>
        </i-form>
        <spin fix v-if="changeLoadingShow">
          <Icon type="load-c" size=18 class="demo-spin-icon-load"></Icon>
          <div>请求中</div>
        </spin>
      </Drawer>
    </Card>
  </div>
</template>
<script>
import Tables from '_c/tables'
import { getList, saveProjectflow, cancelProjectflow } from '@/api/projectflow'
import { getLanguageList } from '@/api/dictionary'
import { getGitlabGroupList } from '@/api/gitlab'
import { GetALLUsers } from '@/api/user'
import { forEach } from '@/libs/tools'
import { getNameList } from '@/api/project'
import { getProjectJob } from '@/api/job'
export default {
  name: 'ProjectFlowList',
  components: {
    Tables
  },
  data () {
    var that = this
    const validateGroup = (rule, value, callback) => {
      if (!value && this.group_visible) {
        callback(new Error('项目所在组不能为空 !'))
      } else {
        callback()
      }
    }
    const valiProjectName = (rule, value, callback) => {
      // 判断是否为空
      if (!value) {
        callback(new Error('项目英文名字不能为空 !'))
      }
      // 判断是否符合正则规则
      // let patt = /^[a-zA-Z0-9]{4,20}$/
      // if (!patt.test(value)) {
      //   callback(new Error('请输入4-20位英文字符(不能包含特殊字符) !'))
      // }
      // 异步判断名字是否和数据库里面数据有重复
      if (!this.projectNameValid(value)) {
        callback(new Error('项目名字有重复，请重新输入'))
      } else {
        callback()
      }
    }
    return {
      isProjectflowAdd: false,
      isProjectflowEdit: false,
      isProjectflowView: false,
      isProjectflowDelete: false,
      project_type_show: false,
      change: false,
      count: 1,
      size: 10,
      page: 1,
      ordering: null,
      status: null,
      searchForm: {
        name: null
      },
      statusArray: [
        {
          label: '开始',
          value: 'start'
        },
        {
          label: '待审',
          value: 'todo'
        },
        {
          label: '通过',
          value: 'agree'
        },
        {
          label: '完成',
          value: 'done'
        },
        {
          label: '出错',
          value: 'error'
        },
        {
          label: '拒绝',
          value: 'refuse'
        },
        {
          label: '取消',
          value: 'cancel'
        }
      ],
      tableData: [],
      columns: [
        { title: 'ID', key: 'id', align: 'center', sortable: 'custom', minWidth: 80 },
        { title: '申请者', key: 'user', align: 'center', minWidth: 100 },
        { title: '项目中文名', key: 'name', align: 'center', minWidth: 150 },
        { title: '项目英文名', key: 'name_en', align: 'center', minWidth: 110 },
        { title: '申请时间', key: 'time_start', align: 'center', sortable: 'custom', minWidth: 150 },
        { title: '完成时间', key: 'time_end', align: 'center', sortable: 'custom', minWidth: 150 },
        {
          title: '状态',
          key: 'status_verbose',
          align: 'center',
          minWidth: 100,
          sortable: 'custom',
          filters: [],
          filterMultiple: false,
          filterRemote (value, row) {
            if (value.length > 0) {
              that.status = value[0]
            } else {
              that.status = null
            }
            that.getProjectflowsList()
          }
        },
        {
          title: '操作',
          align: 'center',
          minWidth: 130,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'success',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.$router.push({name: 'ProjectFlowDetail', query: {id: params.row.id}})
                    // this.$router.push({path: '/projectflow/ProjectFlowDetail', query: {id: params.row.id}})
                  }
                }
              }, '详情'),
              h('Poptip', {
                props: {
                  confirm: true,
                  placement: 'bottom',
                  title: '你确定要取消吗?',
                  transfer: true
                },
                on: {
                  'on-ok': () => {
                    this.handleCancel(params)
                  }
                }
              }, [
                h('Button', {
                  props: {
                    type: 'error',
                    size: 'small',
                    disabled: !(this.$store.state.user.superuser && ['start', 'todo', 'doing'].indexOf(params.row.status) >= 0)
                  },
                  style: {
                    marginRight: '5px'
                  }
                }, '取消')
              ])
            ])
          }
        }
      ],
      languageList: [],
      gitlabGroupOptions: [],
      user_all: [],
      projectNames: [],
      changeLoadingShow: false,
      group_visible: true,
      formItem: {
        name: '',
        name_en: '',
        language: '',
        project_type: '',
        version_control: 'git',
        group: '',
        host: '',
        masters: [],
        pms: [],
        developers: [],
        tests: [],
        maintain: [],
        description: '',
        steps: [
          {
            id: null,
            name: '',
            group: null,
            users: [],
            users_all: [],
            users_sel: [],
            order: null,
            type: ''
          }
        ]
      },
      listStyle: {
        width: '250px',
        height: '300px'
      },
      ruleValidate: {
        name: [{ required: true, message: '项目名(中文)不能为空 !', trigger: 'blur' }],
        name_en: [{ required: true, validator: valiProjectName, trigger: 'blur' }],
        language: [
          { required: true, message: '开发语言不能为空 !', trigger: 'change' }
        ],
        group: [
          { required: true, validator: validateGroup, trigger: 'change' }
        ],
        version_control: [
          { required: true, message: '版本管理工具不能为空 !', trigger: 'change' }
        ],
        masters: [
          { required: true, message: '项目经理不能为空 !', trigger: 'change', type: 'array' }
        ],
        developers: [
          { required: true, message: '开发人员不能为空 !', trigger: 'change', type: 'array' }
        ],
        description: [
          { required: true, message: '描述信息不能为空 !', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    // 初始化页面按钮权限（增删改查操作权限）
    initOperatePerm () {
      let permissions = this.$store.state.user.permissions
      if (permissions.indexOf('add_projectflow') > -1) {
        this.isProjectflowAdd = true
      } else {
        this.isProjectflowAdd = false
      }
      if (permissions.indexOf('change_projectflow') > -1) {
        this.isProjectflowEdit = true
      } else {
        this.isProjectflowEdit = false
      }
      if (permissions.indexOf('delete_projectflow') > -1) {
        this.isProjectflowDelete = true
      } else {
        this.isProjectflowDelete = false
      }
      if (permissions.indexOf('view_projectflow') > -1) {
        this.isProjectflowView = true
      } else {
        this.isProjectflowView = false
      }
    },
    initColumn (variable) {
      this.columns[6].filters = this.statusArray
    },
    initGroup (value) {
      this.ruleValidate.group[0].required = value
    },
    getProjectflowsList (value = 1) {
      this.page = value

      let params = {
        page: this.page,
        ordering: this.ordering,
        status: this.status,
        search: this.searchForm.name
      }
      getList(params).then(res => {
        this.tableData = res.data.results
        this.count = res.data.count
      })
    },
    projectNameValid (value) {
      getNameList().then(res => {
        this.projectNames = res.data
      })
      if (this.projectNames.indexOf(value) > -1) {
        return false
      } else {
        return true
      }
    },
    drawerClose () {
      let that = this.formItem
      that.name = ''
      that.name_en = ''
      that.language = ''
      that.project_type = ''
      that.version_control = ''
      that.group = ''
      that.host = ''
      that.masters = []
      that.pms = []
      that.developers = []
      that.tests = []
      that.maintain = []
      that.description = ''
    },
    fetchProjectJobData () {
      getProjectJob().then(res => {
        if (res.data.steps instanceof Array) {
          let steps = res.data.steps
          if (res.data.ordered) {
            steps.sort(function (a, b) {
              return a.order - b.order
            })
          }
          this.formItem.steps = steps
        }
      })
    },
    searchReset () {
      this.searchForm.name = null
    },
    getLanguages () {
      getLanguageList().then(res => {
        this.languageList = res.data
      })
    },
    onSelectLaguageChange (value) {
      if (value === 'C#') {
        this.project_type_show = true
      } else {
        this.project_type_show = false
      }
    },
    onSelectGitOrSvn (value) {
      if (value === 'git') {
        this.group_visible = true
      } else {
        this.group_visible = false
      }
      this.initGroup(this.group_visible)
    },
    fetchAllGitlabGroupData () {
      getGitlabGroupList().then(res => {
        this.gitlabGroupOptions = res.data
      })
    },
    fetchAllUserData () {
      GetALLUsers().then(res => {
        this.user_all = res.data
      })
    },
    addProject () {
      this.fetchAllUserData()
      this.change = true
    },
    changeSort (column) {
      if (column.key === 'id') {
        if (column.order === 'asc') {
          this.ordering = 'id'
        } else {
          this.ordering = '-id'
        }
      } else if (column.key === 'time_start') {
        if (column.order === 'asc') {
          this.ordering = 'time_start'
        } else {
          this.ordering = '-time_start'
        }
      } else if (column.key === 'time_end') {
        if (column.order === 'asc') {
          this.ordering = 'time_end'
        } else {
          this.ordering = '-time_end'
        }
      } else if (column.key === 'status_verbose') {
        if (column.order === 'asc') {
          this.ordering = 'status_code'
        } else {
          this.ordering = '-status_code'
        }
      }
      this.getProjectflowsList()
    },
    handleCancel (params) {
      cancelProjectflow(params.row.id).then(res => {
        if (res.status === 204) {
          this.$Message.success('取消工作流成功')
          this.getProjectflowsList()
        }
      })
    },
    handleSubmit (name) {
      let that = this.formItem
      this.$refs[name].validate((valid) => {
        if (valid) {
          forEach(this.formItem.steps, (item, index) => {
            let stepName = 'step_' + (index + 1)
            if (item.users_sel instanceof Array) {
              this.formItem[stepName] = item.users_sel
            }
          })
          // 把masters、pms、developers、tests、maintain列表型的数据设置为字符型 , 分割
          var users = ['masters', 'pms', 'developers', 'tests', 'maintain']
          forEach(users, (item, index) => {
            this.formItem[item] = this.formItem[item].join(',')
          })
          // 消息暂时写死只传站内信
          this.formItem['messageKey'] = {sms: '0', dingding: '0', wechat: '0', email: '0', message: '1'}
          this.changeLoadingShow = true
          saveProjectflow(this.formItem).then(res => {
            if (res.data.id > 0) {
              this.change = false
              this.$router.push({name: 'ProjectFlowDetail', query: {id: res.data.id}})
            } else {
              // this.$Notice.error({title: res.data})
              this.$Message.error(res.data)
              that.masters = that.masters.split(',')
              that.pms = that.pms.split(',')
              that.developers = that.developers.split(',')
              that.tests = that.tests.split(',')
              that.maintain = that.maintain.split(',')
            }
            // this.$Notice.success({title: '操作成功！'})
            // that.name = ''
            // that.name_en = ''
            // that.language = ''
            // that.project_type = ''
            // that.version_control = ''
            // that.group = ''
            // that.host = ''
            // that.masters = []
            // that.pms = []
            // that.developers = []
            // this.tests = []
            // this.maintain = []
            // this.description = ''
            // this.change = false
            // this.getProjectflowsList()
          }).catch(res => {
            console.log(res.response)
            this.$Notice.error({
              title: '操作失败！ 错误状态码:' + res.request.status,
              desc: res.request.responseText
            })
          })
        } else {
          this.$Notice.error({title: '请检查输入框！'})
        }
        this.changeLoadingShow = false
      })
    }
  },
  mounted: function () {
    this.initOperatePerm()
    this.getProjectflowsList()
    this.getLanguages()
    this.fetchAllGitlabGroupData()
    this.fetchAllUserData()
    this.initColumn()
    this.initGroup(this.group_visible)
    this.fetchProjectJobData()
  }
}
</script>

<style>
.ivu-poptip-body {
  text-align: left !important;
}
</style>
